import { createWrapper } from '../../fhir-react/base';

export const StructureDefinitionWrapper = createWrapper('StructureDefinition', (structureDefinition) => ({
  getOrganizationName(): string {
    return structureDefinition?.useContext?.[0]?.valueReference?.display ?? "";
  },
}));

export type WrappedStructureDefinition = ReturnType<typeof StructureDefinitionWrapper>;